var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-group",attrs:{"id":_vm.id}},[_c('PanelSlot',{on:{"mounted":function($event){return _vm.onPanelMounted($event)}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }